import { render, staticRenderFns } from "./VeJwKsXueshengList.vue?vue&type=template&id=94c66570&scoped=true"
import script from "./VeJwKsXueshengList.vue?vue&type=script&lang=js"
export * from "./VeJwKsXueshengList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c66570",
  null
  
)

export default component.exports